import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { PhonebookUser } from 'src/app/classes/phonebook-user';

@Component({
  selector: 'app-phonebook',
  templateUrl: './phonebook.page.html',
  styleUrls: ['./phonebook.page.scss'],
})
export class PhonebookPage implements OnInit {

  // declare variables
  public assets = environment.assets;
  public searchForm: UntypedFormGroup;
  public proposalList: PhonebookUser[];
  public showList: boolean = false;
  public query: BehaviorSubject<string> = new BehaviorSubject('');


  constructor(private http: HttpClient, private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    // checks query all 300 ms on change
    this.query.pipe(debounceTime(300)).subscribe((query: string) => {
      if (query.length > 2) {
        // gets list of phonebook users
        this.getUsers(query).subscribe(
          result => {
            this.proposalList = result;
            this.showList = true;
          }
        );
      } else {
        this.showList = false;
      }
    });

    // initiate form
    this.searchForm = this.fb.group({
      'search': ''
    });
  }

  // change variable on query change
  public nextQuery() {
    const query = this.searchForm.controls['search'].value;
    if (this.query.getValue() !== query) {
      this.query.next(query);
    }
  }

  // check if person is a psi worker
  public isInternal(user) {
    if (user.email != null && user.email.indexOf('@psi.ch') > -1) {
      return true;
    } else {
      return false;
    }
  }

  // get the users from phonebook api
  public getUsers(query) {
    return this.http.get<PhonebookUser[]>(environment.phone_api + "?search=" + query);
  }

  //opens email client (iOS workaround)
  public openEmail(email) {
    window.location.href = 'mailto:' + email.toLowerCase();
    return false;
  }

}
